// extracted by mini-css-extract-plugin
module.exports = {"location-container--header":"_1PtSF","body":"kRxJF","body-art":"_3ZSJQ","rc-tabs-bar":"n2rTQ","rc-tabs-tab":"+rqHc","rc-tabs-tab-active":"IFT0b"};